<h3 mat-dialog-title>{{ isAdding ? 'Add Advertiser' : 'Edit Advertiser' }}</h3>

<div class="avatar-container" (click)="fileInputAvatar.click()">
  <input id="uploadAvatarInput" #fileInputAvatar type="file" accept=".png, .jpg, .jpeg" (change)="onAvatarImageSelected($event)">
  <div class="icon-container">
    <mat-icon color="primary">photo_camera</mat-icon>
  </div>
  <div class="avatar">
    <lib-photo [url]="photoUrl" width="150px" height="150px" [radius]="'50%'"></lib-photo>
  </div>
</div>


<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div mat-dialog-content class="content">
    <mat-form-field>
      <mat-label>Advertiser name</mat-label>
      <input type="text" required matInput placeholder="" formControlName="name" maxlength="50">
      @if (!form.get('name').valid) {
        <mat-error>Please enter a valid name</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Countries *</mat-label>
      <mat-select formControlName="countries" multiple>
        @for (country of allCountries; track country.iso2) {
          <mat-option [value]="country.iso2">{{ country.name }}</mat-option>
        }
      </mat-select>
      @if (!form.get('countries').valid) {
        <mat-error>At least one country is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput placeholder="" formControlName="description" maxlength="100">
      @if (!form.get('description').valid) {
        <mat-error>Please enter a valid description</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>App to redirect</mat-label>
      <input matInput placeholder="" formControlName="appToRedirect" maxlength="100">
      @if (!form.get('appToRedirect').valid) {
        <mat-error>Please enter a valid app to redirect</mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions class="gap-8">
    <lib-button variant="stroked" type="button" (click)="onClose()">Close</lib-button>
    <lib-button type="submit" variant="raised" color="primary" [disabled]="!form.valid">Save</lib-button>
  </div>

</form>
